"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ZIndexes;
(function (ZIndexes) {
    ZIndexes.Nav = 1;
    ZIndexes.ScrollablePane = 1;
    ZIndexes.FocusStyle = 1;
    ZIndexes.Coachmark = 1000;
    ZIndexes.Layer = 1000000;
    ZIndexes.KeytipLayer = 1000001;
})(ZIndexes = exports.ZIndexes || (exports.ZIndexes = {}));
//# sourceMappingURL=zIndexes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib/styles/zIndexes.js
// module id = 456
// module chunks = 0